// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.FiChevronsDown = function FiChevronsDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "7 13 12 18 17 13"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 6 12 11 17 6"
      }
    }]
  })(props);
};